(function() {
  'use strict';

  if (window.NikuyaPDP01Registered) {
    return;
  }

  window.NikuyaPDP01Registered = true;

  var selectors = {
    form: '.product-single__form',
    variantsJson: '[data-variant-json]',
    currentVariantJson: '[data-current-variant-json]',
    variantInput: '[data-variant-input]',
    masterSelect: '[data-product-select]',
    dynamicVariants: '[data-dynamic-variants-enabled]',
    price: '[data-product-price]',
    priceWrap: '[data-product-price-wrap]',
    comparePrice: '[data-compare-price]',
    comparePriceA11y: '[data-compare-price-a11y]',
    priceA11y: '[data-a11y-price]',
    unitWrap: '[data-unit-price-wrapper]',
    unitPrice: '[data-unit-price]',
    unitBase: '[data-unit-base]',
    originalAddButton: '[data-nikuya-original-purchase] [data-add-to-cart]',
    originalAddText: '[data-nikuya-original-purchase] [data-add-to-cart-text]',
    stickyBar: '[data-nikuya-sticky-bar]',
    stickyPrice: '[data-nikuya-sticky-price]',
    stickySubmit: '[data-nikuya-sticky-submit]',
    stickySubmitText: '[data-nikuya-sticky-submit-text]',
    gallery: '[data-nikuya-gallery]',
    galleryTrack: '[data-nikuya-gallery-track]',
    galleryItem: '[data-nikuya-media-item]',
    galleryDot: '[data-nikuya-gallery-dot]',
    trioOpen: '[data-nikuya-trio-open]',
    trioDialog: '[data-nikuya-trio-dialog]',
    trioLayout: '.nikuya-pdp-01__dialog-layout',
    trioClose: '[data-nikuya-trio-close]',
    trioForm: '[data-nikuya-ajax-form]'
  };

  function parseJson(element, fallback) {
    if (!element) {
      return fallback;
    }

    try {
      return JSON.parse(element.textContent);
    } catch (error) {
      console.error('Nikuya PDP 01 could not parse product data.', error);
      return fallback;
    }
  }

  function NikuyaPDP01(container) {
    this.container = container;
    this.sectionId = container.dataset.sectionId;
    this.productHandle = container.dataset.productHandle;
    this.abortController = new AbortController();
    this.signal = this.abortController.signal;
    this.galleryObserver = null;
    this.purchaseObserver = null;
    this.stickyHideTimer = null;
    this.returnFocusElement = null;
    this.photoSwipe = null;
    this.hasPassedPurchase = false;
    this.mobileQuery = window.matchMedia('(max-width: 767px)');
    this.galleryQuery = window.matchMedia('(max-width: 1023px)');

    this.form = container.querySelector(selectors.form);
    this.originalAddButton = container.querySelector(selectors.originalAddButton);
    this.originalAddText = container.querySelector(selectors.originalAddText);
    this.stickyBar = container.querySelector(selectors.stickyBar);
    this.stickySubmit = container.querySelector(selectors.stickySubmit);
    this.stickySubmitText = container.querySelector(selectors.stickySubmitText);
    this.dialog = container.querySelector(selectors.trioDialog);
    this.variants = parseJson(container.querySelector(selectors.variantsJson), []);
    this.currentVariant = parseJson(container.querySelector(selectors.currentVariantJson), null);

    this.initCommerce();
    this.initGallery();
    this.initStickyPurchase();
    this.initTrioDialog();
    this.initSharedUtilities();
  }

  NikuyaPDP01.prototype = Object.assign({}, NikuyaPDP01.prototype, {
    initCommerce: function() {
      if (!this.form || !this.variants.length || !window.theme) {
        return;
      }

      this.container.addEventListener('variantChange', this.onVariantChange.bind(this), {signal: this.signal});

      if (theme.Variants) {
        this.variantController = new theme.Variants({
          container: this.container,
          enableHistoryState: false,
          singleOptionSelector: selectors.variantInput,
          originalSelectorId: selectors.masterSelect,
          variants: this.variants,
          dynamicVariantsEnabled: Boolean(this.container.querySelector(selectors.dynamicVariants))
        });

        this.currentVariant = this.variantController.currentVariant || this.currentVariant;
      }

      if (
        theme.VariantAvailability &&
        this.container.querySelector(selectors.dynamicVariants) &&
        this.currentVariant &&
        this.container.querySelector(selectors.variantInput)
      ) {
        new theme.VariantAvailability({
          container: this.container,
          namespace: '.nikuya-pdp-01-' + this.sectionId,
          type: this.container.querySelector('.variant-wrapper').dataset.type,
          variantsObject: this.variants,
          currentVariantObject: this.currentVariant
        });
      }

      this.bindAjaxForms();

      this.updateCommerceState(this.currentVariant);
      this.container.classList.add('nikuya-pdp-enhanced');
    },

    bindAjaxForms: function() {
      if (this.ajaxFormsBound || this.signal.aborted) return;
      if (!window.theme || !theme.AjaxProduct) {
        document.addEventListener('nikuya:dawn-cart:ready', this.bindAjaxForms.bind(this), {once: true, signal: this.signal});
        return;
      }
      this.ajaxFormsBound = true;
      if (this.form) new theme.AjaxProduct(this.form);
      this.container.querySelectorAll(selectors.trioForm).forEach(function(form) {
        form.addEventListener('ajaxProduct:added', this.closeTrioDialog.bind(this), {signal: this.signal});
        new theme.AjaxProduct(form);
      }.bind(this));
    },

    onVariantChange: function(event) {
      this.currentVariant = event.detail.variant;
      this.updateCommerceState(this.currentVariant);
      this.showVariantMedia(this.currentVariant);
      this.updateHistoryState(this.currentVariant);
    },

    updateHistoryState: function(variant) {
      if (!variant || !window.history.replaceState) {
        return;
      }

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({path: url.href}, '', url.href);
    },

    updateCommerceState: function(variant) {
      var available = Boolean(variant && variant.available);
      var buttonText = available ? this.getDefaultAddText() : (variant ? theme.strings.soldOut : theme.strings.unavailable);

      if (this.originalAddButton) {
        this.originalAddButton.disabled = !available;
        this.originalAddButton.classList.toggle('disabled', !available);
      }

      if (this.originalAddText) {
        this.originalAddText.textContent = buttonText;
      }

      if (this.stickySubmit) {
        this.stickySubmit.disabled = !available;
      }

      if (this.stickySubmitText) {
        this.stickySubmitText.textContent = buttonText;
      }

      if (!variant) {
        return;
      }

      this.updatePrice(variant);
      this.updateUnitPrice(variant);
    },

    getDefaultAddText: function() {
      if (this.originalAddText && this.originalAddText.dataset.defaultText) {
        return this.originalAddText.dataset.defaultText;
      }

      return 'Add to cart';
    },

    updatePrice: function(variant) {
      var price = this.container.querySelector(selectors.price);
      var stickyPrice = this.container.querySelector(selectors.stickyPrice);
      var comparePrice = this.container.querySelector(selectors.comparePrice);
      var compareWrap = this.container.querySelector(selectors.priceWrap);
      var compareA11y = this.container.querySelector(selectors.comparePriceA11y);
      var priceA11y = this.container.querySelector(selectors.priceA11y);
      var formattedPrice = theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat);
      var onSale = variant.compare_at_price > variant.price;

      if (price) {
        price.textContent = formattedPrice;
        price.classList.toggle('on-sale', onSale);
      }

      if (stickyPrice) {
        stickyPrice.textContent = formattedPrice;
      }

      if (compareWrap) {
        compareWrap.classList.toggle('hide', !onSale);
      }

      if (comparePrice) {
        comparePrice.textContent = onSale
          ? theme.Currency.formatMoney(variant.compare_at_price, theme.settings.moneyFormat)
          : '';
      }

      if (compareA11y) {
        compareA11y.setAttribute('aria-hidden', onSale ? 'false' : 'true');
      }

      if (priceA11y) {
        priceA11y.textContent = onSale ? priceA11y.dataset.saleLabel : priceA11y.dataset.regularLabel;
      }
    },

    updateUnitPrice: function(variant) {
      var wrapper = this.container.querySelector(selectors.unitWrap);
      var price = this.container.querySelector(selectors.unitPrice);
      var base = this.container.querySelector(selectors.unitBase);

      if (!wrapper) {
        return;
      }

      if (variant.unit_price && variant.unit_price_measurement) {
        if (price) {
          price.textContent = theme.Currency.formatMoney(variant.unit_price, theme.settings.moneyFormat);
        }
        if (base) {
          base.textContent = theme.Currency.getBaseUnit(variant);
        }
        wrapper.classList.remove('hide');
      } else {
        wrapper.classList.add('hide');
      }
    },

    initSharedUtilities: function() {
      if (window.theme && theme.collapsibles) {
        theme.collapsibles.init(this.container);
      }

      var gallery = this.container.querySelector(selectors.gallery);
      if (gallery && window.theme && theme.Photoswipe) {
        this.photoSwipe = new theme.Photoswipe(gallery, this.sectionId);

        gallery.querySelectorAll('.js-photoswipe__zoom').forEach(function(trigger) {
          trigger.addEventListener('click', function() {
            window.requestAnimationFrame(function() {
              var photoSwipeGallery = this.photoSwipe && this.photoSwipe.gallery;
              if (!photoSwipeGallery) {
                return;
              }

              photoSwipeGallery.listen('destroy', function() {
                if (!this.signal.aborted && trigger.isConnected) {
                  trigger.focus();
                }
              }.bind(this));
            }.bind(this));
          }.bind(this), {signal: this.signal});
        }.bind(this));
      }

      var modelViewers = this.container.querySelectorAll('[data-product-media-type-model]');
      if (modelViewers.length && window.theme && theme.ProductMedia) {
        theme.ProductMedia.init(modelViewers, this.sectionId);
      }
    },

    initGallery: function() {
      this.galleryTrack = this.container.querySelector(selectors.galleryTrack);
      this.galleryItems = Array.prototype.slice.call(this.container.querySelectorAll(selectors.galleryItem));
      this.galleryDots = Array.prototype.slice.call(this.container.querySelectorAll(selectors.galleryDot));

      if (!this.galleryTrack || !this.galleryItems.length) {
        return;
      }

      this.galleryDots.forEach(function(dot) {
        dot.addEventListener('click', function() {
          var index = Number(dot.dataset.nikuyaGalleryDot);
          this.scrollToMedia(index);
        }.bind(this), {signal: this.signal});
      }.bind(this));

      this.onGalleryBreakpointChange = function() {
        this.setupGalleryObserver();
      }.bind(this);
      this.onMobileBreakpointChange = function() {
        this.setStickyVisibility(this.hasPassedPurchase && this.mobileQuery.matches);
      }.bind(this);
      if (this.galleryQuery.addEventListener) {
        this.galleryQuery.addEventListener('change', this.onGalleryBreakpointChange, {signal: this.signal});
        this.mobileQuery.addEventListener('change', this.onMobileBreakpointChange, {signal: this.signal});
      } else {
        this.galleryQuery.addListener(this.onGalleryBreakpointChange);
        this.mobileQuery.addListener(this.onMobileBreakpointChange);
        this.legacyGalleryQueryListener = this.onGalleryBreakpointChange;
        this.legacyMobileQueryListener = this.onMobileBreakpointChange;
      }

      this.setupGalleryObserver();
    },

    setupGalleryObserver: function() {
      if (this.galleryObserver) {
        this.galleryObserver.disconnect();
        this.galleryObserver = null;
      }

      if (!this.galleryQuery.matches || !('IntersectionObserver' in window)) {
        this.setActiveDot(0);
        return;
      }

      this.galleryObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.55) {
            this.setActiveDot(this.galleryItems.indexOf(entry.target));
          }
        }.bind(this));
      }.bind(this), {
        root: this.galleryTrack,
        threshold: [0.55]
      });

      this.galleryItems.forEach(function(item) {
        this.galleryObserver.observe(item);
      }.bind(this));
    },

    scrollToMedia: function(index) {
      var item = this.galleryItems[index];
      if (!item || !this.galleryTrack) {
        return;
      }

      this.galleryTrack.scrollTo({
        left: item.offsetLeft - this.galleryTrack.offsetLeft,
        behavior: this.prefersReducedMotion() ? 'auto' : 'smooth'
      });
      this.setActiveDot(index);
    },

    setActiveDot: function(index) {
      this.galleryDots.forEach(function(dot, dotIndex) {
        var active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        if (active) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    },

    showVariantMedia: function(variant) {
      if (!variant || !variant.featured_media || !this.galleryQuery.matches) {
        return;
      }

      var mediaId = String(variant.featured_media.id);
      var index = this.galleryItems.findIndex(function(item) {
        return item.dataset.mediaId === mediaId;
      });

      if (index >= 0) {
        this.scrollToMedia(index);
      }
    },

    initStickyPurchase: function() {
      if (!this.originalAddButton || !this.stickyBar || !this.stickySubmit) {
        return;
      }

      this.stickySubmit.addEventListener('click', function() {
        if (!this.form || !this.originalAddButton || this.originalAddButton.disabled) {
          return;
        }
        this.form.requestSubmit(this.originalAddButton);
      }.bind(this), {signal: this.signal});

      if (!('IntersectionObserver' in window)) {
        return;
      }

      this.purchaseObserver = new IntersectionObserver(function(entries) {
        var entry = entries[0];
        this.hasPassedPurchase = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        this.setStickyVisibility(this.hasPassedPurchase && this.mobileQuery.matches);
      }.bind(this), {threshold: 0});

      this.purchaseObserver.observe(this.originalAddButton);
    },

    setStickyVisibility: function(visible) {
      window.clearTimeout(this.stickyHideTimer);

      if (visible) {
        this.stickyBar.hidden = false;
        window.requestAnimationFrame(function() {
          this.stickyBar.classList.add('is-visible');
        }.bind(this));
        return;
      }

      this.stickyBar.classList.remove('is-visible');
      this.stickyHideTimer = window.setTimeout(function() {
        if (!this.stickyBar.classList.contains('is-visible')) {
          this.stickyBar.hidden = true;
        }
      }.bind(this), this.prefersReducedMotion() ? 0 : 200);
    },

    initTrioDialog: function() {
      if (!this.dialog) {
        return;
      }

      this.container.querySelectorAll(selectors.trioOpen).forEach(function(trigger) {
        trigger.addEventListener('click', function() {
          this.openTrioDialog(trigger);
        }.bind(this), {signal: this.signal});
      }.bind(this));

      var closeButton = this.dialog.querySelector(selectors.trioClose);
      if (closeButton) {
        closeButton.addEventListener('click', this.closeTrioDialog.bind(this), {signal: this.signal});
      }

      this.dialog.addEventListener('cancel', function(event) {
        event.preventDefault();
        this.closeTrioDialog();
      }.bind(this), {signal: this.signal});

      this.dialog.addEventListener('click', function(event) {
        if (event.target === event.currentTarget) {
          event.preventDefault();
          event.stopPropagation();
          this.closeTrioDialog();
        }
      }.bind(this), {signal: this.signal});

      this.dialog.addEventListener('keydown', this.trapDialogFocus.bind(this), {signal: this.signal});
      this.dialog.addEventListener('close', this.restoreDialogFocus.bind(this), {signal: this.signal});
    },

    openTrioDialog: function(trigger) {
      if (!this.dialog || this.dialog.open) {
        return;
      }

      this.returnFocusElement = trigger;
      this.dialog.showModal();
      document.documentElement.classList.add('nikuya-trio-dialog-open');

      var dialogLayout = this.dialog.querySelector(selectors.trioLayout);
      if (dialogLayout) {
        dialogLayout.scrollTop = 0;
      }

      window.requestAnimationFrame(function() {
        var closeButton = this.dialog.querySelector(selectors.trioClose);
        if (closeButton) {
          closeButton.focus();
        }
      }.bind(this));
    },

    closeTrioDialog: function() {
      if (this.dialog && this.dialog.open) {
        this.dialog.close();
      }
    },

    restoreDialogFocus: function() {
      document.documentElement.classList.toggle(
        'nikuya-trio-dialog-open',
        Boolean(document.querySelector(selectors.trioDialog + '[open]'))
      );

      if (this.returnFocusElement && this.returnFocusElement.isConnected) {
        this.returnFocusElement.focus();
      }
      this.returnFocusElement = null;
    },

    trapDialogFocus: function(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        this.closeTrioDialog();
        return;
      }

      if (event.key !== 'Tab') {
        return;
      }

      var focusable = Array.prototype.slice.call(this.dialog.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )).filter(function(element) {
        return !element.hidden && element.offsetParent !== null;
      });

      if (!focusable.length) {
        event.preventDefault();
        return;
      }

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    },

    prefersReducedMotion: function() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    },

    onUnload: function() {
      this.abortController.abort();
      window.clearTimeout(this.stickyHideTimer);

      if (this.purchaseObserver) {
        this.purchaseObserver.disconnect();
      }
      if (this.galleryObserver) {
        this.galleryObserver.disconnect();
      }
      if (this.legacyMobileQueryListener) {
        this.mobileQuery.removeListener(this.legacyMobileQueryListener);
      }
      if (this.legacyGalleryQueryListener) {
        this.galleryQuery.removeListener(this.legacyGalleryQueryListener);
      }
      if (this.dialog && this.dialog.open) {
        this.returnFocusElement = null;
        this.dialog.close();
      }
      document.documentElement.classList.toggle(
        'nikuya-trio-dialog-open',
        Boolean(document.querySelector(selectors.trioDialog + '[open]'))
      );
      if (this.photoSwipe && this.photoSwipe.gallery) {
        this.photoSwipe.gallery.close();
      }
      if (window.theme && theme.ProductMedia) {
        theme.ProductMedia.removeSectionModels(this.sectionId);
      }

      this.container.querySelectorAll('video').forEach(function(video) {
        if (typeof video.pause === 'function') {
          video.pause();
        }
      });
    }
  });

  function registerSection() {
    if (!window.theme || !theme.sections) {
      return;
    }

    theme.sections.register('nikuya-pdp-01', NikuyaPDP01);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', registerSection, {once: true});
  } else {
    registerSection();
  }
})();
